import { useEffect, useState } from 'react';
import { verifyFeatureAccess, verifyReferralManagementAccess } from '../../global/featureFlags';

export const SETUP_ASSISTANT_FEATURE = 'referral_setup_assistant';

/**
 * Setup access for the signed-in user: `'checking'` while `isAdmin` is null
 * (auth not loaded yet) or until every check resolves, then `'allowed'` only
 * when `isAdmin` is set and the org has `referral_setup_assistant`,
 * `medsender_gpt` and referral management. A non-admin is `'denied'` at once,
 * without any check; a failed check is `'denied'`.
 */
const useSetupAssistantAccess = (isAdmin) => {
  const [status, setStatus] = useState('checking');

  useEffect(() => {
    if (!isAdmin) return undefined;
    let isMounted = true;
    setStatus('checking');
    Promise.all([
      verifyFeatureAccess(SETUP_ASSISTANT_FEATURE),
      verifyFeatureAccess('medsender_gpt'),
      verifyReferralManagementAccess(),
    ]).then((results) => {
      if (isMounted) setStatus(results.every((result) => result === true) ? 'allowed' : 'denied');
    }).catch(() => {
      if (isMounted) setStatus('denied');
    });
    return () => {
      isMounted = false;
    };
  }, [isAdmin]);

  if (isAdmin === null || isAdmin === undefined) return 'checking';
  return isAdmin ? status : 'denied';
};

export const useSetupAssistantAllowed = (isAdmin) => useSetupAssistantAccess(isAdmin) === 'allowed';

export default useSetupAssistantAccess;
